/**
 * 运动页比赛卡片类型：父组件根据接口或路由传入的标志位选择对应组件。
 * @example v-if="item.cardVariant === SPORT_CARD_VARIANT.THREE_WAY"
 */
export const SPORT_CARD_VARIANT = Object.freeze({
  THREE_WAY: 'three-way',
  TWO_WAY: 'two-way',
});
